export default class BrowserUtils {
  static isIE() {
    let userAgent = window.navigator.userAgent.toLowerCase()
    return userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1
  }
}
